export interface CoordinateCandidate {
  lat: number;
  lng: number;
}

export interface CoordinateSearchResult {
  id: string;
  type: 'Feature';
  place_type: ['coordinate'];
  place_name: string;
  text: string;
  center: [number, number];
  geometry: { type: 'Point'; coordinates: [number, number] };
  properties: Record<string, never>;
  relevance: number;
}

const SEPARATOR = /[\s,;]+/;
const DECIMAL_DEGREES = /^[+-]?(\d+(\.\d+)?|\.\d+)$/;

const MAX_LAT = 90;
const MAX_LNG = 180;

const isLat = (n: number) => Number.isFinite(n) && Math.abs(n) <= MAX_LAT;
const isLng = (n: number) => Number.isFinite(n) && Math.abs(n) <= MAX_LNG;

export function parseCoordinateQuery(query: string): CoordinateCandidate[] {
  if (typeof query !== 'string') return [];

  const parts = query.trim().split(SEPARATOR).filter(Boolean);
  if (parts.length !== 2) return [];
  if (!parts.every((p) => DECIMAL_DEGREES.test(p))) return [];

  const [a, b] = parts.map(Number);
  if (!Number.isFinite(a) || !Number.isFinite(b)) return [];

  const candidates: CoordinateCandidate[] = [];
  if (isLat(a) && isLng(b)) candidates.push({ lat: a, lng: b });
  if (a !== b && isLat(b) && isLng(a)) candidates.push({ lat: b, lng: a });
  return candidates;
}

const format = (n: number) => String(n);

function toSearchResult(candidate: CoordinateCandidate): CoordinateSearchResult {
  const { lat, lng } = candidate;
  const label = `Lat ${format(lat)}, Lng ${format(lng)}`;
  return {
    id: `coordinate.${format(lat)},${format(lng)}`,
    type: 'Feature',
    place_type: ['coordinate'],
    place_name: label,
    text: label,
    center: [lng, lat],
    geometry: { type: 'Point', coordinates: [lng, lat] },
    properties: {},
    relevance: 1,
  };
}

export function coordinateSearchResults(query: string): CoordinateSearchResult[] {
  return parseCoordinateQuery(query).map(toSearchResult);
}
